import { render, staticRenderFns } from "./QuotasView.vue?vue&type=template&id=0056a684&scoped=true&"
import script from "./QuotasView.vue?vue&type=script&lang=js&"
export * from "./QuotasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0056a684",
  null
  
)

export default component.exports